'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of auto refill calendar
 */ const AutoRefillCalendar = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M24.0312 36.6445H77.0153V70.4362C77.0153 74.6436 73.6045 78.0544 69.3971 78.0544H26.0628C24.9408 78.0544 24.0312 77.1448 24.0312 76.0229V36.6445Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M24.0312 30.1897C24.0312 29.0677 24.9408 28.1582 26.0628 28.1582H74.9838C76.1057 28.1582 77.0153 29.0677 77.0153 30.1897V36.6459H24.0312V30.1897Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M35.2158 41.6152H27.8906V48.9404H35.2158V41.6152Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M48.0869 41.6152H40.7617V48.9404H48.0869V41.6152Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M60.9697 41.6152H53.6445V48.9404H60.9697V41.6152Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M73.8564 41.6152H66.5312V48.9404H73.8564V41.6152Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M35.2158 54.2224H27.8906V61.5476H35.2158V54.2224Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M48.0908 54.2227H40.7656V61.5478H48.0908V54.2227Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M35.2158 66.8418H27.8906V74.167H35.2158V66.8418Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M48.0908 66.8418H40.7656V74.167H48.0908V66.8418Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M32.4599 32.1809C31.3771 32.1809 30.5 31.3038 30.5 30.221V25.4267C30.5 24.3439 31.3771 23.4668 32.4599 23.4668C33.5427 23.4668 34.4198 24.3439 34.4198 25.4267V30.2184C34.4198 31.3012 33.5427 32.1783 32.4599 32.1783V32.1809Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M44.7724 32.1809C43.6896 32.1809 42.8125 31.3038 42.8125 30.221V25.4267C42.8125 24.3439 43.6896 23.4668 44.7724 23.4668C45.8552 23.4668 46.7323 24.3439 46.7323 25.4267V30.2184C46.7323 31.3012 45.8552 32.1783 44.7724 32.1783V32.1809Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M59.0487 25.4267C59.0487 24.3443 58.1712 23.4668 57.0888 23.4668C56.0064 23.4668 55.1289 24.3443 55.1289 25.4267V30.221C55.1289 31.3034 56.0064 32.1809 57.0888 32.1809C58.1712 32.1809 59.0487 31.3034 59.0487 30.221V25.4267Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M69.3974 32.1809C68.3146 32.1809 67.4375 31.3038 67.4375 30.221V25.4267C67.4375 24.3439 68.3146 23.4668 69.3974 23.4668C70.4802 23.4668 71.3573 24.3439 71.3573 25.4267V30.2184C71.3573 31.3012 70.4802 32.1783 69.3974 32.1783V32.1809Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M66.5332 52.1445C58.7469 52.1445 52.4102 58.4812 52.4102 66.2675C52.4102 74.0538 58.7469 80.3906 66.5332 80.3906C74.3195 80.3906 80.6562 74.0538 80.6562 66.2675C80.6562 58.4812 74.3195 52.1445 66.5332 52.1445Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M73.7535 62.2522L73.5398 63.4756C73.3731 63.1018 73.1464 62.7751 72.7679 62.521C72.2666 62.1795 71.6614 62 70.9624 62C70.1755 62 69.4315 62.21 68.7494 62.6112C68.0674 63.0135 67.4762 63.5796 67.0078 64.2949C66.8101 64.5931 66.6274 64.9198 66.4906 65.2632L67.2645 65.7538C67.597 65.9481 67.7948 66.3199 67.7948 66.7065C67.7798 67.1539 67.5072 67.5709 67.0977 67.7936L65.9453 68.3901C65.9603 68.7031 66.0072 69.0013 66.0971 69.2849C66.3238 69.9854 66.7043 70.5211 67.2495 70.9077C67.7948 71.2942 68.4768 71.4738 69.2667 71.4738C69.9638 71.4738 70.6299 71.3099 71.251 70.996C71.7214 70.7586 72.0719 70.4171 72.3595 70.0433L72.1308 71.3394H75.3593L76.9981 62.2531H73.7535V62.2522ZM72.9357 66.781C72.8128 67.509 72.5402 68.0752 72.1617 68.4774C71.7683 68.866 71.282 69.0583 70.7057 69.0583C70.1295 69.0583 69.6892 68.866 69.4475 68.4774C69.2058 68.0909 69.1439 67.5395 69.2807 66.8115C69.4175 66.0658 69.6772 65.485 70.0856 65.068C70.4791 64.651 70.9634 64.4568 71.5396 64.4568C72.1158 64.4568 72.5402 64.651 72.7849 65.0376C73.0266 65.4398 73.0865 66.0207 72.9367 66.781H72.9357Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M66.6971 67.1016L65.9124 67.5198L61.4384 69.8359C61.3617 69.8792 61.2871 69.894 61.2104 69.894C60.9843 69.894 60.8021 69.7139 60.8489 69.4611L61.1367 67.8789C61.1825 67.6388 61.0162 67.4607 60.7882 67.4607H57.3259C57.0998 67.4607 56.9644 67.2807 57.0082 67.0711L57.1287 66.3843C57.1596 66.1915 57.3567 66.0114 57.5828 66.0114H61.0461C61.2721 66.0114 61.4982 65.8166 61.544 65.5932L61.8317 64.0091C61.8775 63.7552 62.1036 63.5781 62.3316 63.5781C62.4063 63.5781 62.481 63.6067 62.5417 63.6362L66.1843 65.9524L66.8335 66.3705C67.1074 66.5181 67.0307 66.9363 66.6981 67.1006L66.6971 67.1016Z",
                fill: theme.ds5.asset[assetColor]["100"]
            })
        ]
    });
};

exports.AutoRefillCalendar = AutoRefillCalendar;
//# sourceMappingURL=AutoRefillCalendar.cjs.map
